import React, { useState } from 'react';
import SafeIcon from './SafeIcon';
import BrandMark from './BrandMark';
import { FiShare2, FiBell, FiSearch, FiX, FiUser } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

export default function TopBar() {
  const [showShare, setShowShare] = useState(false);

  return (
    <>
      <header className="sticky top-0 z-40 w-full backdrop-blur-xl bg-midnight-900/80 border-b border-white/5 px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-4 flex-1">
          <div className="relative w-full max-w-md hidden sm:block">
            <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input 
              type="text" 
              placeholder="Query itinerary, places, or logs..." 
              className="w-full bg-white/5 border border-white/10 rounded-full py-2 pl-10 pr-4 text-sm focus:outline-none focus:border-cyan-400/50 text-white placeholder-gray-600 transition-all" 
            />
          </div>
          <div className="md:hidden flex items-center gap-2">
            <BrandMark className="w-8 h-8" />
            <span className="font-mono text-lg font-bold tracking-tighter text-white">RM</span>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <button 
            onClick={() => setShowShare(true)} 
            className="flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-400/10 text-cyan-400 border border-cyan-400/30 hover:bg-cyan-400/20 transition-all text-sm font-medium shadow-[0_0_15px_rgba(0,240,255,0.05)]"
          >
            <SafeIcon icon={FiShare2} />
            <span className="hidden sm:inline uppercase font-mono tracking-wider text-[11px]">Broadcast</span>
          </button>
          
          <button className="relative p-2 text-gray-400 hover:text-white transition-colors">
            <SafeIcon icon={FiBell} className="text-xl" />
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-coral-400 rounded-full shadow-[0_0_8px_rgba(255,107,107,0.8)]"></span>
          </button>

          <div className="w-9 h-9 rounded-full bg-gradient-to-tr from-cyan-400 to-coral-400 p-[1.5px] shadow-[0_0_15px_rgba(0,240,255,0.2)]">
            <div className="w-full h-full rounded-full bg-midnight-900 flex items-center justify-center overflow-hidden">
              <img 
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=100&q=80" 
                alt="User" 
                className="w-full h-full object-cover opacity-90" 
                onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }}
              />
              <SafeIcon icon={FiUser} className="hidden text-gray-400" />
            </div>
          </div>
        </div>
      </header>

      {/* Share Modal */}
      <AnimatePresence>
        {showShare && (
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-midnight-900/90 backdrop-blur-md"
          >
            <motion.div 
              initial={{ scale: 0.9, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.9, y: 20 }}
              className="glass-card w-full max-w-sm p-8 relative overflow-hidden"
            >
              <div className="absolute top-0 left-0 w-full h-1 bg-cyan-400"></div>
              <button onClick={() => setShowShare(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors">
                <SafeIcon icon={FiX} className="text-xl" />
              </button>
              
              <div className="flex flex-col items-center text-center">
                <BrandMark className="w-16 h-16 mb-6" />
                <h3 className="text-xl font-mono text-white mb-2 tracking-widest">BROADCAST PLAN</h3>
                <p className="text-xs text-gray-500 mb-8 max-w-[220px]">Scan to synchronize this itinerary with your travel group.</p>
                
                <div className="aspect-square w-48 bg-white p-3 rounded-2xl mb-8 relative">
                  <div className="w-full h-full border-2 border-midnight-900 flex flex-col items-center justify-center gap-2 opacity-90">
                    <BrandMark className="w-12 h-12" color="#050A15" />
                    <span className="font-mono text-midnight-900 font-black text-xs tracking-[0.2em]">RM-TX-SYNC</span>
                  </div>
                </div>

                <div className="w-full flex gap-2">
                  <input type="text" readOnly value="routemuse.io/p/tk77" className="flex-1 bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-xs text-gray-400 font-mono focus:outline-none" />
                  <button className="px-6 py-3 bg-cyan-400 text-midnight-900 font-bold rounded-xl hover:bg-white transition-all text-xs uppercase tracking-widest">
                    Copy
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}